export const actionTypes = {
  BANK_ACCOUNTS_REQUEST_START: 'USER_INCOMES.BANK_ACCOUNTS.REQUEST_START',
  BANK_ACCOUNTS_REQUEST_SUCCESS: 'USER_INCOMES.BANK_ACCOUNTS.REQUEST_SUCCESS',
  BANK_ACCOUNTS_REQUEST_FAILURE: 'USER_INCOMES.BANK_ACCOUNTS.REQUEST_FAILURE',
  BANK_ACCOUNTS_SET_DATA_PRESENTED: 'USER_INCOMES.BANK_ACCOUNTS.SET_DATA_PRESENTED',
  BANK_ACCOUNTS_RESET: 'USER_INCOMES.BANK_ACCOUNTS.BANK_ACCOUNTS_RESET',
};

export function fetchBankAccounts(filters) {
  return {
    type: actionTypes.BANK_ACCOUNTS_REQUEST_START,
    payload: filters,
  };
}

export function fetchBankAccountsSuccess(data) {
  return {
    type: actionTypes.BANK_ACCOUNTS_REQUEST_SUCCESS,
    payload: data,
  };
}

export function setBankAccountsDataPresented(isDataPresented) {
  return {
    type: actionTypes.BANK_ACCOUNTS_SET_DATA_PRESENTED,
    payload: isDataPresented,
  };
}

export function fetchBankAccountsFailure(error) {
  return {
    type: actionTypes.BANK_ACCOUNTS_REQUEST_FAILURE,
    payload: error,
  };
}

export function bankAccountsReset() {
  return {
    type: actionTypes.BANK_ACCOUNTS_RESET,
  };
}
